/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxfWatchlistV1Fincen314MatchState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXF_WATCHLIST_V1_FINCEN314_MATCH_STATE_ENTITY_NAME = 'ixf.watchlist.v1.Fincen_314Match';
export const ixfWatchlistV1Fincen314MatchStateEntity = new schema.Entity<IxfWatchlistV1Fincen314MatchState>(IXF_WATCHLIST_V1_FINCEN314_MATCH_STATE_ENTITY_NAME, {}, { idAttribute: 'fincen314MatchId' });

